module.exports = __webpack_public_path__ + "img/icon-heart-o.ad8f6ff2.svg";